import { useContext } from "react";
import { AlertContext } from "../../context/AlertContext";

const typeStyles = {
  success: "bg-success_bg border-success_border text-success",
  error:   "bg-danger_bg  border-danger_border  text-danger",
  warning: "bg-warning_bg border-warning_border text-warning",
  info:    "bg-info_bg    border-info_border    text-info",
};

export default function Alert() {
  const { alerts, dismiss } = useContext(AlertContext);

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm w-full pointer-events-none">
      {alerts.map((a) => (
        <div
          key={a.id}
          className={`pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-lg border text-sm font-medium shadow-md animate-toast-in ${typeStyles[a.type] ?? typeStyles.info}`}
        >
          <span className="flex-1">{a.message}</span>
          <button
            onClick={() => dismiss(a.id)}
            className="opacity-60 hover:opacity-100 text-base leading-none"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
